const currencyPositionEnum = Object.freeze({
    LEFT: 5,
    RIGHT: 10
});
export default currencyPositionEnum;
